import { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';

//Components
import { Grid } from '@mui/material';
import { Loading, Checkbox, Button } from "@gpstrackit/react-controls";

import { HasPermission } from "Core/security";

//Actions
import {
    featureTabRequest,
    clearRedux,
    featureTabOpenModal
} from 'Redux/actions';
import { set } from 'lodash';

const FeatureTab = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const { device } = props;

    const { loading, result } = useSelector(state => state.featureTabRedux);
    const { user } = useSelector(state => state.securityRedux);

    const [show, setShow] = useState(false);
    const [promiles, setPromiles] = useState(false)
    const [promilesOdometerCalculated, setPromilesOdometerCalculated] = useState(false);
    const [apu, setApu] = useState(false);
    const [useEcuOdometer, setUseEcuOdometer] = useState(false);
    const [driverBehavior, setDriverBehavior] = useState(false);
    const [jbus, setJbus] = useState(false);
    const [vbus, setVbus] = useState(false);
    const [hybrid, setHybrid] = useState(false);
    const [currentDevice, setCurrentDevice] = useState(null);
    const [analytics, setAnalytics] = useState(false);
    const [useEcuSpeed, setUseEcuSpeed] = useState(false);
    const [useEcuVin, setUseEcuVin] = useState(false);
    const [cariq, setCariq] = useState(false);
    const [carb, setCarb] = useState(false);
    const [useEcuEngineHours, setUseEcuEngineHours] = useState(false);

    useEffect(() => {
        if (result) {
            setCurrentDevice(result)
            setShow(result?.show);
            setPromiles(result?.promiles);
            setPromilesOdometerCalculated(result?.promilesOdometerCalculated)
            setApu(result?.apu);
            setUseEcuOdometer(result?.useEcuOdometer);
            setDriverBehavior(result?.driverBehavior);
            setJbus(result?.jbus);
            setVbus(result?.vbus);
            setHybrid(result?.hybrid);
            setAnalytics(result?.analytics);
            setUseEcuSpeed(result?.useEcuSpeed);
            setUseEcuVin(result?.useEcuVin);
            setCariq(result?.cariq);
            setCarb(result?.carb);
            setUseEcuEngineHours(result?.useEcuEngineHours);

            dispatch(clearRedux("FEATURE_TAB", { result: null }))
        }
    }, [result])

    useEffect(() => {
        return () => {
            dispatch(clearRedux("FEATURE_TAB"));
            setShow(false);
            setPromiles(false);
            setPromilesOdometerCalculated(false);
            setApu(false);
            setUseEcuOdometer(false);
            setDriverBehavior(false);
            setJbus(false);
            setVbus(false);
            setHybrid(false);
            setUseEcuVin(false);
            setCariq(false);
            setCarb(false);
        }
    }, [])

    useEffect(() => {
        dispatch(featureTabRequest(device.id))
    }, [])

    return (
        <>
            {loading && <Loading overlay show />}
            <div className="sim-info-container">
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <div style={{ display: 'flex', justifyContent: 'end' }}>
                            <Button
                                className="btn-dark-blue"
                                disabled={!HasPermission(user, "unt", "u")}
                                onClick={() => {
                                    dispatch(featureTabOpenModal(device?.id))
                                }}
                            >
                                {messages['feature_tab_edit_features']}
                            </Button>
                        </div>
                    </Grid>
                    <Grid item xs={3}>
                        <Checkbox
                            id="tab-show-in-web"
                            label={messages['feature_tab_show_in_web']}
                            value={show}
                            onChange={(checked) => { }}
                            disabled
                        />
                    </Grid>
                    {currentDevice?.deviceModel?.promiles &&
                        <Grid item xs={3}>
                            <Checkbox
                                id="tab-promiles"
                                label={messages['feature_tab_promiles']}
                                value={promiles}
                                onChange={(checked) => { }}
                            />
                        </Grid>
                    }
                    {currentDevice?.deviceModel?.promiles &&
                        <Grid item xs={3}>
                            <Checkbox
                                id="tab-send-calc-odometer"
                                label={messages['feature_tab_send_calc_odometer']}
                                value={promilesOdometerCalculated}
                                onChange={(checked) => { }}
                            />
                        </Grid>
                    }
                    {
                        currentDevice?.deviceModel?.analytic &&
                        <Grid item xs={3}>
                            <Checkbox
                                id="tab-analytics"
                                label={messages['feature_tab_analytics']}
                                value={analytics}
                                onChange={(checked) => { }}
                            />
                        </Grid>
                    }
                    <Grid item xs={3}>
                        <Checkbox
                            id="tab-apu"
                            label={messages['feature_tab_apu']}
                            value={apu}
                            onChange={(checked) => { }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <Checkbox
                            id="tab-hybrid"
                            label={messages['feature_tab_hybrid']}
                            value={hybrid}
                            onChange={(checked) => { }}
                        />
                    </Grid>
                    {
                        (currentDevice?.deviceModel?.vbus || currentDevice?.deviceModel?.manufacturer?.name?.toUpperCase() === "ZONAR") &&
                        <Grid item xs={3}>
                            <Checkbox
                                id="tab-vbus"
                                label={messages['feature_tab_vbus']}
                                value={vbus}
                                onChange={(checked) => { }}
                            />
                        </Grid>
                    }
                    {
                        (currentDevice?.deviceModel?.jbus || currentDevice?.deviceModel?.manufacturer?.name?.toUpperCase() === "ZONAR") &&
                        <Grid item xs={3}>
                            <Checkbox
                                id="tab-jbus"
                                label={messages['feature_tab_jbus']}
                                value={jbus}
                                onChange={(checked) => { }}
                            />
                        </Grid>
                    }
                    {
                        ((currentDevice?.deviceModel?.odometerEnable && (currentDevice?.deviceModel?.vbus || currentDevice?.deviceModel?.jbus)) || currentDevice?.deviceModel?.manufacturer?.name?.toUpperCase() === "ZONAR") &&
                        <>
                            <Grid item xs={3}>
                                <Checkbox
                                    id="tab-show-ecu-speed"
                                    label={messages['feature_tab_show_ecu_speed']}
                                    value={useEcuSpeed}
                                    onChange={(checked) => { }}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <Checkbox
                                    id="tab-use-ecu-odometer"
                                    label={messages['feature_tab_use_ecu_odometer']}
                                    value={useEcuOdometer}
                                    onChange={(checked) => { }}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <Checkbox
                                    id="tab-use-ecu-vin"
                                    label={messages['feature_tab_use_ecu_vin']}
                                    value={useEcuVin}
                                    onChange={(checked) => { }}
                                />
                            </Grid>
                        </>
                    }
                    {
                        ((currentDevice?.deviceModel?.useEcuEngineHours && (currentDevice?.deviceModel?.vbus || currentDevice?.deviceModel?.jbus)) || currentDevice?.deviceModel?.manufacturer?.name?.toUpperCase() === "ZONAR") &&
                        <>
                            <Grid item xs={3}>
                                <Checkbox
                                    id="tab-use-ecu-engine-hours"
                                    label={messages['feature_tab_use_ecu_engine_hours']}
                                    value={useEcuEngineHours}
                                    onChange={(checked) => { }}
                                />
                            </Grid>
                        </>
                    }
                    {
                        currentDevice?.deviceModel?.driverBehavior &&
                        <Grid item xs={3}>
                            <Checkbox
                                id="tab-driver-behavior"
                                label={messages['feature_tab_driver_behavior']}
                                value={driverBehavior}
                                onChange={(checked) => { }}
                            />
                        </Grid>
                    }
                    {
                        currentDevice?.deviceModel?.cariq &&
                        <Grid item xs={3}>
                            <Checkbox
                                id="tab-caiq"
                                label={messages['feature_tab_cariq']}
                                value={cariq}
                                onChange={(checked) => { }}
                            />
                        </Grid>
                    }
                    {
                        currentDevice?.deviceModel?.carbEnable &&
                        <Grid item xs={3}>
                            <Checkbox
                                id="tab-carb"
                                label={messages['feature_tab_carb']}
                                value={carb}
                                onChange={(checked) => { }}
                            />
                        </Grid>
                    }
                </Grid>
            </div>
        </>
    )
}
export default FeatureTab;